export default {
    //动画函数
    animationIndex(domTop, styleClassList, animation, time, fn) {
        let scrollTop = document.documentElement.scrollTop; //获取滚动条滚动高度
        let clientHeight = document.documentElement.clientHeight; //获取当前屏幕的高度
        if (scrollTop > domTop - clientHeight) {
            // let that = this;
            for (var i = 0; i < styleClassList.length; i++) { //循环和定时器结合使用，会出现同步异步情况，这里使用闭包处理。
                (function(a) {
                    setTimeout(function() {
                        styleClassList[a].add(animation)
                    }, a * time);
                })(i)
            }
        }
    }
}